export const EXECUTION_RESULTS = {
  SKIPPED: "SKIPPED",
  PENDING: "PENDING",
  PASSED: "PASSED",
  FAILED: "FAILED",
  UNKNOWN: "UNKNOWN",
} as const;

export default EXECUTION_RESULTS;
